<template>
    <div class="white-list page list-page">
        <div class="page--list"  v-loading="loading">
            <div class="scroll-wrapper pd4 set--bottom-foot-padding">
                <list-search-bar  @search.stop="handleSearch" @clear.stop="handleClearBtn"
                     inline>
                    <el-form-item label="操作账号" >
                        <el-input v-model.trim="SP_.searchValue" class="width2"></el-input>
                    </el-form-item>

                    <el-form-item label="操作日期" >
                        <el-date-picker
                        v-model="SP_.searchStartTime"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                        <div class="hw_ml5 hw_mr5">-</div>
                        <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="SP_.searchEndTime"
                        placeholder="选择日期">
                        </el-date-picker>
                       
                     </el-form-item>
                </list-search-bar>
                <el-table :data="tableData">
                    <el-table-column label="操作日期" prop="createTimeName"></el-table-column>
                    <el-table-column label="操作账号" prop="createEmpAccount"></el-table-column>
                    <el-table-column label="变更前的客户编号" prop="sourceCustCode"></el-table-column>
                    <el-table-column label="变更后的客户编号" prop="desCustCode"></el-table-column>
                    <el-table-column label="操作的订单编号" prop="orderNo"></el-table-column>
                    <el-table-column label="操作备注" prop="remark"></el-table-column>
                </el-table>

            </div>
            <list-foot-bar >
                

                <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="SP.pageNum"
                    :page-size="SP.pageSize"
                    :total="total"
                    @size-change="handlePageSizeChange"
                    @current-change="handlePageNoChange"
                ></el-pagination>
            </list-foot-bar>
        </div>
    </div>
</template>
<script>
import forList from "@/mixin/forList";
export default {
    
    mixins: [forList],
    data() {
        return {

            SP_: {
                searchValue: "",
                searchStartTime:'',
                searchEndTime:''
            }
        }
    },
    methods: {
        async fetchData() {
            const loading = this.$loading();
            try {
               
                const res = await this.$axios({
                    url: "/api/order/queryTransferCustList",
                    method: "post",
                    data: {
                         ...{ // 参数不足会报错，，
							searchValue: "",     // 
                            searchStartTime:'',
                            searchEndTime:''
                        },
                         ...this.SP
                    }
                })
                console.log("合并日志",res)
                if (res.code === 2000) {
                   this.total = res.data.count;
                   this.tableData = res.data.transferCustList;
                   loading?.close();

                } else if (res.code !== 1003){
                     throw res
                }
                   

            } catch(reason)  {
                console.warn("失败", reason)
                 loading?.close();
            }
        }
    }
}
</script>